module.exports = __webpack_public_path__ + "img/folder.a2816f64.svg";